import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const GameNavButton = forwardRef(({ label, disabled, onClick, isCurrent }, ref) => {
    return (_jsx("button", { className: `game-nav-button ${isCurrent ? 'pending' : 'new'}`, onClick: onClick, disabled: disabled, ref: ref, children: _jsx("span", { children: label }) }));
});
export default GameNavButton;
